module.exports = __webpack_public_path__ + "static/img/a069.1b7e45e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a069.jpg
// module id = hA5W
// module chunks = 0